export class ListDynamoDbBackupConfigsResponse {
    'configs';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "configs",
            "baseName": "configs",
            "type": "Array<DynamoDbBackupConfig>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDynamoDbBackupConfigsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
